import Vue from 'vue'
import Vuex from 'vuex'
import 'es6-promise/auto'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

function initialState () {
  return {
    country: '',
    token_dtCreation: '',
    token_dtUpdate: '',
    lastAccess: '',
    mail: '',
    user: '',
    nomex: '',
    cognx: '',
    societa: '',
    desSoc: '',
    tel1: '',
    localita: '',
    /* DATI MESSAGGISTICA */
    messaggiCount: {},
    menu: {
      area: '',
      codiApp: '',
      label: {
        it_IT: '',
        fr_FR: '',
        es_ES: '',
        de_DE: '',
        en_GB: ''
      }
    }
  }
}

export default new Vuex.Store({
  state: initialState(),
  mutations: {
    set (state, payload) {
      state[payload.key] = payload.value
    },
    setValue (state, obj) {
      state[obj.form][obj.field] = obj.value
    },
    reset (state) {
      const initState = initialState()
      Object.keys(initState).forEach(key => {
        state[key] = initState[key]
      })
    }
  },
  actions: {
    /* ACTIONS GENERICHE */
    ifObject (context, campo) {
      if (Object.keys(context.state[campo]).length !== 0 && context.state[campo].constructor === Object) {
        return true
      }
      return false
    },
    ifValue (context, campo) {
      if (context.state[campo] !== '' && context.state[campo] !== null && context.state[campo] !== undefined) {
        return true
      }
      return false
    }
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
})



// WEBPACK FOOTER //
// ./src/components/Store.js